var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"kui-validatebox",style:({width: _vm.width})},[_vm._t("validatebox-content"),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTips),expression:"isShowTips"}],staticClass:"validatebox-message"},[_vm._v(_vm._s(_vm.validateMsg))])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70e6d68a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/style-rem-loader??ref--1!./src/lib/ui/default/validatebox/index.vue
// module id = 1477
// module chunks = 2